import {
  Alert,
  AlertTitle,
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import { HomescreenBannerDraggableTable } from '../../components/DraggableTable/HomescreenBannerDraggableTable';
import { RefreshButton } from '../../components/Buttons/RefreshButton';
import { CommonButton } from '../../components/Buttons';
import { useNavigate } from 'react-router-dom';
import { CREATE_HOMESCREEN_BANNER_ROUTE } from '../../constants/routes';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IRootState } from '../../types/store';
import { HomebannerService } from '../../api/services/homebannerService';
import { resetData, setBannerGroups, setHomebanners } from '../../store/Reducers/HomebannersSlice';
import { showNotification } from '../../store/Reducers/NotificationSnackbarSlice';
import './styles.scss';

export const HomescreenBannerPage = () => {
  const navigate = useNavigate();
  const [selectedBannerGroup, setSelectedBannerGroup] = useState<string>(``);
  const { bannerGroups } = useSelector((state: IRootState) => state.homebanners);
  const dispatch = useDispatch();

  const onChangeSelectedBannerGroup = (selectedBannerGroup: string) => {
    setSelectedBannerGroup(selectedBannerGroup);
  };

  const setBannerGroupsData = async () => {
    const groups = await HomebannerService.getHomebannerGroups();
    dispatch(setBannerGroups(groups));
    return groups;
  };

  const setHomebannersData = async (groupName: string) => {
    const homebannersByGroup = await HomebannerService.getHomebannersByGroup(groupName);
    dispatch(setHomebanners(homebannersByGroup));
  };

  const reloadData = async (bannerGroup: string) => {
    setHomebannersData(bannerGroup);
  };

  const initData = async () => {
    try {
      const groups = await setBannerGroupsData();
      setHomebannersData(groups[0]);
      setSelectedBannerGroup(groups[0]);
    } catch {
      dispatch(
        showNotification({
          message: 'Failed to load homebanners. Please reload page.',
          severity: 'error',
        }),
      );
      dispatch(resetData());
    }
  };

  useEffect(() => {
    initData();
  }, []);

  useEffect(() => {
    if (selectedBannerGroup?.length) {
      reloadData(selectedBannerGroup);
    }
  }, [selectedBannerGroup]);

  return (
    <>
      <Box sx={{ mb: 2 }}>
        <Alert severity="info">
          <AlertTitle>Note</AlertTitle>
          You can drag the rows to adjust the sequence of the homebanners.
        </Alert>
      </Box>
      <Box sx={{ mb: 2, gap: 2, display: 'flex' }}>
        <RefreshButton
          onClick={() => {
            reloadData(selectedBannerGroup);
          }}
        />
        <FormControl>
          <InputLabel id="banner-group-select-label">Banner Group</InputLabel>
          <Select
            labelId="banner-group-select-label"
            id="banner-group-select"
            value={selectedBannerGroup}
            label="Banner Group"
            onChange={(e: SelectChangeEvent) => {
              onChangeSelectedBannerGroup(e.target.value);
            }}
          >
            {bannerGroups?.map((group: string) => {
              return (
                <MenuItem key={group} value={group}>
                  {group}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
        <CommonButton
          label={'Add Banner'}
          onClick={() => {
            navigate(CREATE_HOMESCREEN_BANNER_ROUTE, {
              state: {
                selectedBannerGroup: selectedBannerGroup,
              },
            });
          }}
        />
      </Box>
      <HomescreenBannerDraggableTable selectedBannerGroup={selectedBannerGroup} />
    </>
  );
};
